import { useMemo } from "react";
import { getEffectiveAccess } from "../services/authSessionService";
import {
  adminRolesFromAccess,
  canShowContractsModule,
  canShowPrizeRulesModule,
} from "../utils/sessionModuleAccess";

export function useModuleAccess() {
  const effectiveAccess = getEffectiveAccess();
  const adminRoles = adminRolesFromAccess(effectiveAccess);

  return useMemo(
    () => ({
      effectiveAccess,
      adminRoles,
      canContracts: canShowContractsModule(effectiveAccess, adminRoles),
      canPrizeRules: canShowPrizeRulesModule(effectiveAccess, adminRoles),
    }),
    [effectiveAccess, adminRoles],
  );
}
